import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { yupResolver } from '@hookform/resolvers/yup'
import useFlow from 'modules/flow/state/use-flow'
import useOrder from 'modules/order/state/order/use-order'
import { DEFAULT_THEME_COLORS } from '../../../../css/theme'
import FlowOneColumnStepLayout from '../one-column-step-layout/one-column-step-layout'
import OrderContactQuestions2 from 'modules/order/components/contact-questions/contact-questions-2'
import { OrderContactAnswersSlice } from 'modules/order/state/contact-answers/contact-answers-types'

import {
  trackFormSkipEvent,
  trackFormSubmitEvent,
} from '../../../analytics/helpers/track-form-events'
import { FormWithoutStyles } from '../shared/form.styled'
import useConfig from '../../../config/state/use-config'

type FormData = OrderContactAnswersSlice

const AdditionalDonorInformationStep = () => {
  const flow = useFlow()
  const order = useOrder()
  const config = useConfig()
  const { t } = useTranslation()

  const primaryColor =
    config.theme['--theme-color__brand-primary'] ||
    DEFAULT_THEME_COLORS['--theme-color--neutral-10']

  const form = useForm<FormData>({
    values: order.contactAnswers.value,
    resolver: yupResolver(order.contactAnswers.schema),
  })

  const goNext = () => {
    flow.nextStep && flow.goToStep(flow.nextStep.name)
  }

  const onSubmit = async (data: FormData) => {
    trackFormSubmitEvent(flow.currentStep.name)

    order.contactAnswers.save(data)
    order.contactAnswers.setValue(data)

    goNext()
  }

  const onSkip = () => {
    trackFormSkipEvent(flow.currentStep.name)

    goNext()
  }

  return (
    <FormProvider {...form}>
      <FormWithoutStyles onSubmit={form.handleSubmit(onSubmit)}>
        <FlowOneColumnStepLayout.Main title={flow.currentStep.title}>
          <div style={{ width: '100%', maxWidth: 500 }}>
            <OrderContactQuestions2 showRequired={false} />
          </div>
        </FlowOneColumnStepLayout.Main>
        <FlowOneColumnStepLayout.Footer>
          <FlowOneColumnStepLayout.FooterButton
            size="lg"
            type="button"
            color={DEFAULT_THEME_COLORS['--theme-color--neutral-100']}
            borderColor={DEFAULT_THEME_COLORS['--theme-color--neutral-80']}
            onClick={onSkip}
            dataId="additional-information-step-skip-button"
          >
            {t('AdditionalDonorInformationStep.footer.skip', 'Skip')}
          </FlowOneColumnStepLayout.FooterButton>
          <FlowOneColumnStepLayout.FooterButton
            size="lg"
            type="submit"
            color={primaryColor}
            dataId="additional-information-step-continue-button"
          >
            {t('AdditionalDonorInformationStep.footer.continue', 'Continue')}
          </FlowOneColumnStepLayout.FooterButton>
        </FlowOneColumnStepLayout.Footer>
      </FormWithoutStyles>
    </FormProvider>
  )
}

export default AdditionalDonorInformationStep
